export const getEmployeePayrollList = state => {
    return state.list
}

export const getEmployeePayrollDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/employeePayroll/getters.js